import { Card, Header } from '@bp/ui-components';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CardPicker } from '../CardPicker/CardPicker';
import { useTeachingBlockStore } from '../Contexts/TeachingBlockContext';
import styles from './GridActionArea.module.scss';

export const GridActionArea: FC = observer(() => {
  const { t } = useTranslation();

  const store = useTeachingBlockStore();

  const headline = t('pinboard.showSelectionFor', { type: getSelectionType() });

  const selection = store.selectedRows
    .map((row) => row.label)
    .sort()
    .join(', ');

  function getSelectionType() {
    switch (store.gridContext) {
      case 'classes':
        return t('classes.title', { count: 1 });
      case 'teachers':
        return t('persons.title', { count: 2 });
      default:
        break;
    }
  }

  return (
    <Card
      className={styles['grid-action-area']}
      wrapperClass={classNames(styles.wrapper)}
      contentPadding='none'
      fitContent
    >
      <Header
        className={styles.header}
        headline={selection ? headline : ''}
        subHeadline={selection ?? undefined}
        size='s'
        actions={[
          {
            text: t('pinboard.actions.showTimetable'),
            disabled: true,
            hierarchy: 'tertiary',
          },
        ]}
      />
      <CardPicker />
    </Card>
  );
});
